;(function($, undefined){

  /* Takes b64 encoded data strings and replaces their inner contents */
  function initB64() {
    document.querySelectorAll('[data-b64]').forEach(function(element){
      element.innerHTML = atob(element.getAttribute('data-b64'))
    })
    document.querySelectorAll('[data-click-b64]').forEach(function(element){
      element.addEventListener('click', function(){
        element.innerHTML = atob(element.getAttribute('data-click-b64'))
      })
    })
    document.querySelectorAll('[data-mobile-click-b64]').forEach(function(element){
      element.addEventListener('click', function(e){
        e.preventDefault;
        e.stopPropagation;
        var telephone = atob(element.getAttribute('data-mobile-click-b64'));
        element.innerHTML = "<a href='tel:" + telephone + "'>" + telephone + "</a>";
      })
    })
  }

  window.rnn.modules.register("b64", { init: initB64 });

})(jQuery);
